import styled from 'styled-components';

export const SectionHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	font-weight: ${({ theme }) => theme.fontWeights.bold};
	font-size: ${({ theme }) => theme.fontSizes.large};
	margin-bottom: 4px;
	height: 32px; 
`;